import React from 'react';
import { QuestionMark } from 'react-design-components';
import { HelpModal } from 'react-commons';
import { BusinessChoiceWrapper, BusinessChoiceButton } from '../Elements';
import { BusinessTypeHelp } from '../Help';
import { GastroIcon, BueroIcon, PraxisIcon, RetailIcon, SonstigesIcon } from '../Icons';
import { FlowEnum, BusinessTypeEnum } from '../../types';
import useBusinessType from './hooks/useBusinessType';
import { MainLayout } from '../MainLayout';
import Greeting from './Greeting';

export interface Props {
  nextUrl: string;
  progress?: number;
  flow?: FlowEnum;
}

const BusinessType: React.FC<Props> = (props: Props) => {
  const { progress, flow } = props;
  const { t, classes, toggleHelpModal, onClick } = useBusinessType(props);

  return (
    <MainLayout flow={flow} progress={progress} directAccess t={t} pageTitle="business_type_page_title">
      <HelpModal>
        <BusinessTypeHelp />
      </HelpModal>
      <div className={classes.alignBottom}>
        <Greeting displayGreeting={false}>
          <QuestionMark onHelpClick={toggleHelpModal} title={t('business_type_title')}>
            <BusinessChoiceWrapper>
              <BusinessChoiceButton onClick={() => onClick(BusinessTypeEnum.OFFICE)}>
                <span className={classes.businessChoiceTitle}>{t('business_type_office')}</span>
                <span>
                  <BueroIcon width={48} heigth={48} />
                </span>
              </BusinessChoiceButton>
              <BusinessChoiceButton onClick={() => onClick(BusinessTypeEnum.RETAIL)}>
                <span className={classes.businessChoiceTitle}>{t('business_type_retail')}</span>
                <span>
                  <RetailIcon width={48} heigth={48} />
                </span>
              </BusinessChoiceButton>
              <BusinessChoiceButton onClick={() => onClick(BusinessTypeEnum.GASTRO)}>
                <span className={classes.businessChoiceTitle}>{t('business_type_gastro')}</span>
                <span>
                  <GastroIcon width={48} heigth={48} />
                </span>
              </BusinessChoiceButton>
              <BusinessChoiceButton onClick={() => onClick(BusinessTypeEnum.MEDICINE)}>
                <span className={classes.businessChoiceTitle}>{t('business_type_medicine')}</span>
                <span>
                  <PraxisIcon width={48} heigth={48} />
                </span>
              </BusinessChoiceButton>
              <BusinessChoiceButton onClick={() => onClick(BusinessTypeEnum.MISCELLANEOUS)}>
                <span className={classes.businessChoiceTitle}>{t('business_type_miscellaneous')}</span>
                <span>
                  <SonstigesIcon width={48} heigth={48} />
                </span>
              </BusinessChoiceButton>
            </BusinessChoiceWrapper>
          </QuestionMark>
        </Greeting>
      </div>
    </MainLayout>
  );
};

export default BusinessType;
